import { get } from "../../utils/object-helpers";

$ {
    const logoTitle = get(input, 'logo.title', '');
    const logoLink = get(input, 'logo.action.URL', '');
    const logoAccessibility = get(input, 'logo.action.accessibilityText', '');
    const logoTracking = JSON.stringify(get(input, 'logo.action.trackingList.0', ''));
    const editLogoAction = get(input, 'editLogoAction');
    const profileEditState = get(input, 'globalState.profileEdit', null);
}

<section class="str-header__logo--wrapper">
    <a
        class="str-header__logo str-header__logo--rounded"
        aria-label=logoAccessibility
        href=logoLink
        data-track=logoTracking
    >
        <img
            class="str-header__logo--img"
            src=state.logoUrl
            title=logoTitle
            alt=logoTitle
            data-testid="hdr-logo"
        />
    </a>
    <if(profileEditState?.editing && editLogoAction)>
        $ {
            const menuEntries = get(editLogoAction, 'editMenu.entries', []);
            const iconAddA11y = get(editLogoAction, 'iconAdd.accessibilityText', '');
            const iconMenuA11y = get(editLogoAction, 'iconMenu.accessibilityText', '');
            const removePrompt = get(editLogoAction, 'removePrompt', {});
        }
        <if(!state.editMenuRequired)>
            <ebay-icon-button
                aria-label=iconAddA11y
                class="str-header__logo--edit-add"
                on-click("addLogo")
                disabled=profileEditState?.saving>
                <ebay-pencil-16-icon/>
            </ebay-icon-button>
        </if>
        <else>
            <ebay-menu-button
                a11y-text=iconMenuA11y
                class="str-header__logo--edit-menu"
                disabled=profileEditState?.saving
                on-select("iconMenuOptionSelected")
                no-toggle-icon>
                <@icon>
                    <ebay-pencil-16-icon/>
                </@icon>
                <for|entry| of=menuEntries>
                    <@item>${entry.paramValue}</@item>
                </for>
            </ebay-menu-button>
        </else>
        <if(state.removeIntention)>
            $ {
                const removePromptTitle = get(removePrompt, 'title', '');
                const removePromptSubTitle = get(removePrompt, 'subTitle', '');
                const removePromptSubmitButton = get(removePrompt, 'submitButton', '');
                const removePromptCancelButton = get(removePrompt, 'cancelButton', '');
            }
            <ebay-lightbox-dialog open
                on-close("cancelLogoRemoval")
                a11y-close-text=removePromptCancelButton.accessibilityText>
                <@header><str-textual-display ...removePromptTitle /></@header>
                <str-textual-display ...removePromptSubTitle />
                <@footer>
                    <ebay-button
                        priority=removePromptCancelButton.type?.toLowerCase()
                        on-click("cancelLogoRemoval")>
                        ${removePromptCancelButton.text}
                    </ebay-button>
                    <ebay-button
                        priority=removePromptSubmitButton.type?.toLowerCase()
                        on-click("confirmLogoRemoval")>
                        ${removePromptSubmitButton.text}
                    </ebay-button>
                </@footer>
            </ebay-lightbox-dialog>
        </if>
    </if>
</section>
